import styled from '@emotion/styled';
import { MOBILE_QRY } from '~/config';

export const PaginationContainer = styled.div<{ width?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid var(--border1);
  border-top: none;
  border-radius: 0 0 4px 4px;
  font-family: 'Poppins', sans-serif;
  width: ${props => props.width ?? '100%'};

  ${MOBILE_QRY} {
    border-radius: 4px;
  }
`;

export const ItemCount = styled.div`
  font-size: 14px;
  color: #56555e;
  display: none;
  text-wrap: nowrap;

  ${MOBILE_QRY} {
    display: block;
  }
`;

export const PageControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 4px;
`;

export const PageButton = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 32px;
  width: 32px;

  min-height: 32px;
  min-width: 32px;

  max-height: 32px;
  max-width: 32px;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;

  border: 1px solid ${({ active }) => (active ? 'var(--prim4)' : '#ddd')};
  background: ${({ active }) => (active ? 'var(--prim4)' : 'transparent')};
  color: ${({ active }) => (active ? '#fff' : '#56555E')};
  border-radius: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ active }) => (active ? 'var(--prim4)' : '#f0f0f0')};
  }
`;

export const Ellipsis = styled.span`
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #56555e;
`;

export const ItemsPerPage = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #56555e;
  opacity: 0;
  display: none;

  ${MOBILE_QRY} {
    display: block;
  }
`;

export const Select = styled.select`
  padding: 4px 8px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
`;
